import UICarousel from 'UIComponents/carousel/UICarousel';
import SingleStepContent from './SingleStepContent';
import { jsx as _jsx } from "react/jsx-runtime";
const CoachingTipSteps = ({
  steps,
  onStepChange
}) => {
  const singleStep = steps && steps.length === 1;
  if (singleStep) {
    return /*#__PURE__*/_jsx(SingleStepContent, {
      step: steps[0]
    });
  }
  return /*#__PURE__*/_jsx(UICarousel, {
    "data-test-id": "coaching-tip-popover-carousel",
    className: "m-top-5",
    steps: steps,
    onStepIndexChange: onStepChange
  });
};
export default CoachingTipSteps;